module.exports = __webpack_public_path__ + "img/09.e08c2c22.jpg";